import { render, staticRenderFns } from "./dc-sso.vue?vue&type=template&id=65cb2815&"
import script from "./dc-sso.vue?vue&type=script&lang=js&"
export * from "./dc-sso.vue?vue&type=script&lang=js&"
import style0 from "./dc-sso.vue?vue&type=style&index=0&id=65cb2815&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports